import React from "react";
import { Link } from "react-router-dom";

const RegisterCard = ({ data }) => {
  return (
    <div className="rounded overflow-hidden shadow-lg border sticky top-10">

      <img
        className="w-full h-48 object-cover"
        src={data.image}
        alt={data.title}
      />

      <div className="p-4">
        <h2 className="text-lg font-semibold mb-2">{data.title}</h2>
        
        {/* <div className="flex items-baseline mb-2">
          <span className="text-2xl text-purple-600 font-bold">
            {data.currentPrice}
          </span>
          <span className="line-through text-gray-500 ml-2">
            {data.originalPrice}
          </span>
          <span className="text-red-500 ml-2">{data.discount}</span>
        </div> */}
        {/* <div className="text-gray-600 mb-4">{data.timeLeft}</div> */}
        
        <div className="flex flex-col gap-2 font-bold">
          <Link
            to="https://forms.gle/qFcfAJ2E5bYBJ2hr8"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary">
            <span className="font-semibold">I'm Interested</span>
          </Link>
        </div>
        <div className="text-sm text-gray-500 mt-2 text-center">
          {/* <span>{data.guarantee}</span> */}
          <br />
          {/* <span>{data.lifetimeAccess}</span> */}
        </div>
      </div>

    </div>
  );
};

export default RegisterCard;
